<div appTheme>

    <div class="app-container">

        <div id="blur-conatiner" [ngClass]="{'blur-background': blurBackground}">

            <app-top-menu-bar *ngIf="showHeader" [isUnAuthenticatedRoute]="isExternalTermsOrPrivacy"></app-top-menu-bar>

            <router-outlet></router-outlet>

        </div>

        <app-footer *ngIf="showFooter" [isUnAuthenticatedRoute]="isExternalTermsOrPrivacy"></app-footer>

    </div>

    <p-growl [life]="4000"></p-growl>

</div>

<app-mail-center></app-mail-center>

<app-firmware-upgrade-progress></app-firmware-upgrade-progress>

<app-app-connectivity #connectionStatus></app-app-connectivity>

<div *ngIf="isProcessing" class="modal-box scrolling" style="z-index: 5000">
    <app-loading [text]="processingMessage" [size]="'fa-5x'"></app-loading>
</div>

<!-- Popup Dialog -->
<!-- N.B., [breakpoint]="0" is key to keep the p-dialog from getting into funky resize state when window width is reduces to <= 640px -->
<p-dialog
    [(visible)]="displayDocument"
    [breakpoint]="0"
    [modal]="true"
    [appendTo]="'body'"
    (onHide)="onHideDialog()"
    [closable]="true"
    [closeOnEscape]="true"
    [showHeader]="true"
    [draggable]="false">
    <p-header>
        {{ Constants.AppName }} - {{ documentName }}
    </p-header>

    <app-document-viewer *ngIf="displayDocument"
        [documentType]="documentType"
        [data]="documentData"
        [enforceMaxWidth]="documentHasMaxWidth">
    </app-document-viewer>
</p-dialog>

<!-- Timeout Modal -->
<p-dialog *ngIf="userIdleDialogIsDisplayed"
    [(visible)]="userIdleDialogIsDisplayed"
    [breakpoint]="0" modal="modal"
    [appendTo]="'body'" [closable]="true"
    [showHeader]="true" [draggable]="false"
    (onHide)="onCloseDialog()">

    <p-header>
        {{ Constants.AppName }} - {{ Constants.Strings.IdleMsg }}
    </p-header>
    <div class="modal-body" style="width: 420px;">
        <div class="row mrgbtm">
            <div class="col-md-12">
                <h4 class="modal-title pull-left">{{idleState}}</h4>
            </div>
        </div>
        <div class="row bottom bottom-buttons">
            <button class="button submit-button" id="logoutBtn" (click)="logoutUser()"> Logout </button>
            <button class="cancel-button button-small" id="extendBtn" (click)="extendUser()" type="button"> Stay </button>
        </div>

    </div>
</p-dialog>
